import FARM_STATUSES from 'Const/farm/status';

export default {
  list: state => state.list || [],
  listCount: state => state.listCount,
  listLoading: state => state.listLoading,
  listLoaded: state => state.listLoaded,
  farmData: state => state.farmData,
  farmDataLoading: state => state.farmDataLoading,
  farmDataLoaded: state => state.farmDataLoaded,
  farmUnfinishedInvestment: state => state.farmUnfinishedInvestment,
  farmUnfinishedInvestmentLoading: state => state.farmUnfinishedInvestmentLoading,
  farmRemainingShares: state => Number(state.farmData?.remaining_shares) || 0,
  farmMinSharesInvestment: (state, getters) => {
    const min = getters.farmData.min_investment;
    const max = getters.farmRemainingShares;
    if (max < (min * 1.15)) return max;
    return min;
  },
  isCanInvest: state => (state.farmData.status === FARM_STATUSES.VERIFIED
    && (state.farmData.percent_subscribed || 0) < 100),
  isUserWatch: state => state.isUserWatch,
  isUserWatchLoading: state => state.isUserWatchLoading,
  farmSortValue: state => state.farmSortValue,
  closedSuccessfullyList: state => state.closedSuccessfullyList,
  closedSuccessfullyListCount: state => state.closedSuccessfullyListCount,
  closedSuccessfullyListLoading: state => state.closedSuccessfullyListLoading,
  listOpenedFarms: (state, getters) => (
    getters.list?.filter(item => item.farmSubscribedPercent < 100) || []
  ),
};
